// Real pages from MATEMATIK KLAR™ Bind 1 (Gamma Studio), reviewed page by page.
const BASE = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/8b8fa9d9-995e-4832-85d2-19be84443c33/';
export const pageSamples: Array<{
  src: string;
  label: string;
  title: string;
  text: string;
}> = [{
  src: BASE + '1792667798300_mk-dk-bind1-side01-936dfd95.webp',
  label: 'Bind 1 · Forside',
  title: 'Tal og regning · 0.–3. klasse',
  text: 'Talforståelse, positionssystemet, tiervenner, gangetabellen og hovedregning – samlet i ét bind.'
}, {
  src: BASE + '1792667802808_mk-dk-bind1-side08-c8d7d68f.webp',
  label: 'Årsplan',
  title: 'Årsplan for 3. klasse – 40 skoleuger',
  text: 'Uge for uge, koblet til Fælles Mål og til lektionerne i bindet.'
}, {
  src: BASE + '1792667806897_mk-dk-bind1-side25-49de43c6.webp',
  label: 'Færdig lektion',
  title: 'Lektion 8 minut for minut',
  text: 'Mål, materialer, tidsforløb på 45 minutter og lærerinstruks med præcise sætninger.'
}, {
  src: BASE + '1792667810915_mk-dk-bind1-side12-f71ff297.webp',
  label: 'Opgaveark i 3 niveauer',
  title: 'Tallene 0–10 – med facit',
  text: 'Støtte, basis og udfordring på samme ark, med facit nederst til læreren.'
}, {
  src: BASE + '1792667814918_mk-dk-bind1-side38-555adcb2.webp',
  label: 'Evaluering',
  title: 'Facit til prøverne',
  text: 'Prøver for 1., 2. og 3. klasse med færdigt facit, så rettearbejdet går hurtigt.'
}];
